export default __webpack_public_path__ + "static/media/tailwindapp.a9469191.png";